import { idaasConfig } from "../constants/idaas_config"
import { convertUrl } from "../helpers/helper"
import { Response } from "../types/backend.type"
import { BillingDetails } from "../types/billingDetails.type"
import { CustomerDetails, CustomerDetailsTaas } from "../types/customerDetails.type"
import { ServiceDetails, ServiceDetailsTaas } from "../types/serviceDetails.type"
import api from "../utils/api"
import http from "../utils/http"

const getCustomerDetails = async (
  token: string
): Promise<Response<CustomerDetails> | undefined> => {
  try {
    // Await the response from getCustomerDetails
    const response = await http.get(`getCustomerDetails`, token)

    // Handle the data
    return response
  } catch (error) {
    console.error('Error fetching customer details:', error);
  }
  
  
}

const getBillingDetails = async (
  token: string,
  body: any
): Promise<Response<BillingDetails>> => {
  const response = await http.post(
    convertUrl(`getBillingDetails`),
    JSON.stringify(body),
    token,
    undefined
  )
  return response
}

const getServiceDetails = async (
  token: string,
  body: any
): Promise<Response<ServiceDetails>> => {
  const response = await http.post(
    convertUrl(`getServiceDetails`),
    JSON.stringify(body),
    token,
    undefined
  )
  return response
}
const getCustomerDetailsTaas = async (
  tassToken: string,
  userInfo: any,
  randomstring: string
): Promise<any> => {
  let formatted = userInfo.national_id_number.slice(0, 6) + '-' + userInfo.national_id_number.slice(6, 8) + '-' + userInfo.national_id_number.slice(8);
  const rbody = {
      idType : "New NRIC",
      idValue : formatted
  }
  const password = "m5zQi5Vu3mI8sFsgLTH91Zaw3b8a"; // Store securely in production
  const encryptedData = encryptData(JSON.stringify(rbody), password);
  const body = {
    encryptedData : encryptedData,
}
const response = await http.getTass(convertUrl(`getCustomerDetailsComposit`), JSON.stringify(body), tassToken,randomstring)
const base64EncryptedData = response.encryptedResponseData;  // Example Base64 encrypted data
 // Decrypt the data from Base64
const decryptedResponse = decryptData(base64EncryptedData, password);
return decryptedResponse;
}

function xorEncryptDecrypt(input: string, key: string): string {
  const inputArray = new TextEncoder().encode(input);
  const keyArray = new TextEncoder().encode(key);

  let resultArray = new Uint8Array(inputArray.length);
  for (let i = 0; i < inputArray.length; i++) {
    resultArray[i] = inputArray[i] ^ keyArray[i % keyArray.length];
  }

  // Convert to base64 encoded string
  const encryptedStr = String.fromCharCode(...resultArray);
  return btoa(encryptedStr);
}

function encryptData(data: string, key: string): string {
  return xorEncryptDecrypt(data, key);
}


const getServiceDetailsTaas = async (
  token: string,
  body: any,
  randomstring: string
): Promise<Response<ServiceDetailsTaas>> => {
  const response = await http.getTass(
    convertUrl('getServiceDetailsComposit'),
    JSON.stringify(body),
    token,
    randomstring
  )
  return response
}
function xorDecrypt(input:any, key:any) {
  const inputArray = new TextEncoder().encode(input);
  const keyArray = new TextEncoder().encode(key);

  let resultArray = new Uint8Array(inputArray.length);
  for (let i = 0; i < inputArray.length; i++) {
    resultArray[i] = inputArray[i] ^ keyArray[i % keyArray.length];
  }

  // Convert result back to string
  return new TextDecoder().decode(resultArray);
}
function decryptData(encryptedData:any, key:any) {
  const decodedData = atob(encryptedData);  // Decode Base64
  return xorDecrypt(decodedData, key);
}
export { getCustomerDetails, getServiceDetails, getBillingDetails, getCustomerDetailsTaas, getServiceDetailsTaas }
